import React, { FC } from "react";
import { useParams } from "react-router";

import { OverlayLoading } from "components/common/OverlayLoading/OverlayLoading";
import { useGetCurrentUserOrderDetails } from "core/services/api/order.api";
import { Badge, Card, CardBody, Col, Row, Table } from "reactstrap";
import { formatToToman } from "core/utils/format";
import { OrderStatusEnum } from "core/enum/order-status.enum";

const OrderDetails: FC = () => {
  const { id } = useParams<any>();

  const { data, isSuccess, isLoading } = useGetCurrentUserOrderDetails(id);

  if (isLoading) {
    return <OverlayLoading />;
  }

  if (!isSuccess || !data?.data?.result) {
    return <div className="text-center mt-5">سفارشی پیدا نشد.</div>;
  }

  const order = data.data.result;

  return (
    <div
      className="container my-4"
      style={{ direction: "rtl", textAlign: "right" }}
    >
      <Card className="mb-4 shadow-sm">
        <CardBody>
          <Row className="mb-3">
            <Col md={6}>
              <strong>شماره سفارش : </strong> {order.orderNumber}
            </Col>
            <Col md={6}>
              <strong>وضعیت سفارش : </strong>{" "}
              <Badge
                color={
                  order.orderStatus === OrderStatusEnum.Payed
                    ? "success"
                    : "warning"
                }
              >
                {order.orderStatusTitle}
              </Badge>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <strong>آدرس : </strong> {order.address}
            </Col>
            <Col md={6}>
              <strong>کد پستی : </strong> {order.postalCode}
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* جدول آیتم‌ها */}
      <Card className="mb-4 shadow-sm">
        <CardBody>
          <Table bordered responsive hover>
            <thead className="table-light">
              <tr className="text-center">
                <th>نام محصول</th>
                <th>توضیحات</th>
                <th>تعداد</th>
                <th>قیمت واحد</th>
              </tr>
            </thead>
            <tbody>
              {order.orderItems.map((item: any) => (
                <tr key={item.id} className="text-center">
                  <td>{item.productTitle}</td>
                  <td>{item.productDescription}</td>
                  <td>{item.quantity}</td>
                  <td>{item.price} ریال</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      {/* خلاصه مالی */}
      <Card className="shadow-sm">
        <CardBody>
          <Row className="mb-3">
            <Col md={6}>
              <strong>جمع کل : </strong> {formatToToman(order.productPrice)}
            </Col>
            <Col md={6}>
              <strong>تخفیف : </strong> {formatToToman(order.discountAmount)}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <strong>مالیات : </strong> {formatToToman(order.taxAmount)}
            </Col>
            <Col md={6}>
              <strong>هزینه ارسال : </strong>{" "}
              {formatToToman(order.shipmentPrice)}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <strong>قابل پرداخت : </strong>{" "}
              <span style={{ color: "red", fontSize: "1.1rem" }}>
                {formatToToman(order.payablePrice)}
              </span>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export { OrderDetails };
